'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _prop = require('lodash/fp/prop');

var _prop2 = _interopRequireDefault(_prop);

var _detectBrowser = require('detect-browser');

var _detectBrowser2 = _interopRequireDefault(_detectBrowser);

var _Maybe = require('../fp/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ieAgents = ['ie', 'edge'];

var isIE = function isIE() {
  return (0, _includes2.default)(ieAgents, (0, _Maybe.maybe)(null, (0, _prop2.default)('name'), _Maybe2.default.of(_detectBrowser2.default.detect())));
};

exports.default = {
  isIE: isIE
};